import injectSheet from 'react-jss';
import {formatPhone} from '@deliveriesondemand/dod-utils';


const styles = theme => ({
    phone: {
        color: theme.colors.primary
    }
});




const ResidencyWarning = props => {
    const {classes, contactPhone} = props;


    return (
        <div style={{backgroundColor: 'white', border: 'solid 5px black', padding: 20, marginBottom: 20}}>
            <p>
                All nonresidents of the United States must call in and complete the application with a 
                Call Center Representative in order to answer any additional questions there might be. 
                Please call <a className={classes.phone} href={`tel:${contactPhone}`}>{formatPhone(contactPhone)}</a>
            </p>
        </div>
    );
};


export default injectSheet(styles)(ResidencyWarning);
